import { createAsyncThunk } from '@reduxjs/toolkit';
import { iStateMessage } from '@/customTypes/GenericReduxTypes';
import { iGenericResponse } from '@/customTypes/CommonServiceTypes';
import { curryGetThunkName } from '@/projectUtils/ReduxUtil';
import { httpStatusCodes } from '@/customTypes/NetworkTypes';
import { employeesService } from '@/services/api/cresivoxServer';
import { REDUCER_NAME } from './Types';

const curriedGetThunkName = curryGetThunkName(REDUCER_NAME);

export const getEmployeeOrderList = createAsyncThunk<
  iGenericResponse<any | null> | null,
  { wholesalerId: string; status: string }, // ✅ FIXED TYPE
  { rejectValue: iStateMessage }
>(


  curriedGetThunkName('getEmployeeOrderList'),
  // @ts-expect-error
  async ({ wholesalerId, status }, { rejectWithValue }) => {
    try {
      const response = await employeesService.getEmployeeOrderList(wholesalerId, status);

       

      if (response) {
        const { httpStatusCode, data, message } = response;
    
        switch (httpStatusCode) {
          case httpStatusCodes.SUCCESS_OK: {
            if (data && (data as any).data) {
              return {
                httpStatusCode,
                data: (data as any).data,
                message,
              };
            }
            return rejectWithValue({ httpStatusCode, message });
          }

          default:
            return rejectWithValue({ httpStatusCode, message });
        }
      }

      return rejectWithValue({
        message: 'No response received',
      });
    } catch (error) {
      return rejectWithValue({
        message: 'Something went wrong',
      });
    }
  }
);
